<template>
  <div
    class="ob1-add-promotional-code d-block">
    <wptv-button
      type="wired"
      :disabled="disabled"
      :background="buttonType"
      data-wptv="coupon-valider"
      @click.native="actionCb()">
      {{ label }}
    </wptv-button>
  </div>
</template>

<script>
import WptvButton from '../../../button/Button.vue'

export default {
  name: 'PromotionalCodeButtonAdd',
  components: {
    WptvButton
  },
  props: {
    darkMode: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    actionCb: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonType () {
      return this.darkMode ? 'black' : 'white'
    }
  }
}
</script>
